import React, { forwardRef, useEffect } from 'react';
import clsx from "clsx";
import logo_img from '@Images/logo.svg';
import logo_white from '@Images/nav_logo.svg';
import { localUser, isEmpty } from '@Util/utils';
import useAuthApi from "@Apis/useAuthApi";
import { HEADER_TYPE } from "@Constants/dataEnums";

const MainHeader = forwardRef(({ headerType = HEADER_TYPE.DEFAULT, headerContent = null }, ref) => {
        const user = localUser.get();
        const { displayName, isLiffBound = false } = user || {};
        const { getLiffBindingApi } = useAuthApi();

        // 功能：是否改由頁面提供的自訂內容取代預設 logo/user（如 Stepper）
        const hasCustomContent = !!headerContent;

        const isLogoCenter = (headerType & HEADER_TYPE.LOGO_CENTER) !== 0;
        const isLogoWhite = (headerType & HEADER_TYPE.LOGO_WHITE) !== 0;
        const isHideBackground = (headerType & HEADER_TYPE.HIDE_BACKGROUND) !== 0;
        const isHideUser = (headerType & HEADER_TYPE.HIDE_USER) !== 0;
        const isBlurredGlass = (headerType & HEADER_TYPE.BLURRED_GLASS) !== 0;
        const isUnfixed = (headerType & HEADER_TYPE.UNFIXED) !== 0;
        
        const doCheckLiffBindingApi = async () => {
            if (isLiffBound) {
                const resp = await getLiffBindingApi();

                if (!resp) {
                    localUser.setToken(null);
                    localUser.set(null);

                    window.location.reload();
                }
            }
        }

        useEffect(
            () => {
                doCheckLiffBindingApi();

                return () => {
                };
            },
            // eslint-disable-next-line
            [],
        );

        return (
            <header ref={ref} className={clsx('header', {
                'logo-center': isLogoCenter,
                'hide-background': isHideBackground,
                'blurred-glass': isBlurredGlass,
                'logo-white': isLogoWhite,
                'unfixed': isUnfixed,
                'has-custom-content': hasCustomContent,
            })}>
                <div className={'container'}>
                    {hasCustomContent ? (
                        headerContent
                    ) : (
                        <>
                            <div className={'header-logo'}>
                                <img src={!isLogoWhite ? logo_img : logo_white} alt={'Curves'} />
                            </div>

                            {!isEmpty(user) && !isHideUser && (
                                <div className="header-user">
                                    <img src="/pic/me/user.jpg" alt={displayName} />
                                    <span>{displayName}</span>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </header>
        );
    }
);

MainHeader.displayName = 'MainHeader';

export default MainHeader;
